<div class="notes-container">
    <ms-inline-tooltip [tooltipPlacement]="'bottom-start'" [applyClass]="'game-notes-tooltip-msg'">
        <span #tooltipContent class="game-notes">{{ gameNotes }}</span>
    </ms-inline-tooltip>
</div>
